import styled, { css } from 'styled-components';

import { Content } from '../styles';

interface DetailsChartProps {
  color?: string;
  isMetricAvailable?: boolean;
}

export const Container = styled(Content)`
  display: flex;
`;

export const DetailsChart = styled.div<DetailsChartProps>`
  display: flex;
  flex-direction: column;
  justify-content: center;
  align-items: center;
  margin-top: 24px;

  width: 100%;
  max-width: 380px;
  border-radius: 22px;
  border: 1px solid ${({ theme }) => theme.colors.grayAlternative};
  padding: 40px 0;
  margin: 0 auto;

  h2 {
    font-weight: bold;
    font-size: 22px;
    margin-bottom: 50px;
    color: ${({ theme }) => theme.colors.gray3};
    padding: 0;
  }

  div {
    display: flex;

    img {
      width: 100px;
      margin-right: 15px;
    }

    div {
      display: flex;
      flex-direction: column;
      align-items: flex-start;
      justify-content: space-between;

      span {
        font-weight: 500;
        font-size: 18px;
        color: ${({ theme }) => theme.colors.grayAlternative};
      }

      h1 {
        font-weight: bold;
        font-size: 40px;
        color: ${({ color, theme }) => color || theme.colors.primary};
      }
    }
  }
`;

export const ViewOptions = styled.div<DetailsChartProps>`
  display: flex;
  align-items: center;
  gap: 8px;
  margin-top: 8px;
  color: #2d9cdb;
  font-size: 0.75rem;

  button {
    display: flex;
    border-radius: 99999px;
    padding: 6px;
    border: 1px solid ${({ theme }) => theme.colors.grayAlternative};
    background-color: transparent;
    font-weight: 600;

    ${(props) =>
      props.isMetricAvailable &&
      css`
        &:disabled:nth-child(2) {
          background: ${(color) => color.theme.colors.gray};
          color: ${(color) => color.theme.colors.gray3};
          border: 2px solid ${({ theme }) => theme.colors.gray};
        }
      `}

    &:disabled {
      svg {
        color: ${({ theme }) => theme.colors.white};
        border: gray;
      }

      border: 2px solid ${({ theme }) => theme.colors.primary};
      background-color: ${({ theme }) => theme.colors.primary};
      cursor: default;
    }

    svg {
      color: ${({ theme }) => theme.colors.grayAlternative};
    }
  }
`;

export const ViewContent = styled.div`
  display: flex;
  margin-top: 24px;
`;
